import { DataFichaRegistro, FichaRegistro } from "./fichaRegistro.model"

export class ProcedenciaInterface {
  epoca: string
  periodo: string
  fase: string
  anio: string
  tipoEstilo: string
  procedencia: string
  formaAdquisicion: string
  tradicion: string
  autor:string
  constructorTexto:string
  informante:string

  constructor(ficha?: FichaRegistro) {
    this.epoca = ficha?.epoca || '';
    this.periodo = ficha?.periodo || '';
    this.fase = ficha?.fase || '';
    this.anio = ficha?.anio || '';
    this.tipoEstilo = ficha?.tipoEstilo || '';
    this.procedencia = ficha?.procedencia || '';
    this.formaAdquisicion = ficha?.formaAdquisicion || '';
    this.tradicion = ficha?.tradicion || '';
    this.constructorTexto= ficha?.constructor || '';
    this.informante= ficha?.informante || '';
  }


}